export default __webpack_public_path__ + "static/media/banner_blog_7.0b647c8b.png";